import moment from 'moment'
import * as Yup from 'yup'

import { getMessage } from '../../../../../util/IntlMessages'
import { buildFieldsById, evaluateRequired, hasAnswer } from '../components/CustomFields/helpers/requiredRule'
import { actionStatus, actionStatusMap, validationMessages } from '../constants'

export function createValidationSchema(customFields) {
  const baseFieldsSchema = {
    actionSubject: Yup.string().max(60).required(validationMessages.actionSubjectMsg),
    actionTypeId: Yup.number().positive().required(validationMessages.actionTypeIdMsg),
    actionStatusId: Yup.number().positive().required(validationMessages.actionStatusIdMsg),
    customerId: Yup.number().positive().required(validationMessages.customerIdMsg),
    memberId: Yup.number().positive().required(validationMessages.memberIdMsg),
    locationId: Yup.number().positive().required(validationMessages.locationMsg),
    referencePeriodId: Yup.number().positive().required(validationMessages.referencePeriodIdMsg),
    executionDate: Yup.object().when('actionStatusId', {
      is: (actionStatusId) =>
        actionStatusId === actionStatusMap.get(actionStatus.DONE) ||
        actionStatusId === actionStatusMap.get(actionStatus.PLANNED),
      then: (schema) =>
        schema.required(validationMessages.actionPlannedDoneTimeMsg).test({
          name: 'is-valid-date',
          test: (value) => moment(value).isValid(),
          message: validationMessages.actionPlannedDoneTimeMsg
        }),
      otherwise: (schema) => schema.nullable()
    })
    /*
      [Suporte #46638] Visitas - Remover campo "Hora" do formulário principal
      USER STORY 10613 (AzureDevops)
    */
    // executionTime: Yup.object().when('actionStatusId', {
    //   is: (actionStatusId) =>
    //     actionStatusId === actionStatusMap.get(actionStatus.DONE) ||
    //     actionStatusId === actionStatusMap.get(actionStatus.PLANNED),
    //   then: (schema) =>
    //     schema.required(validationMessages.actionsPlannedTimeHourMsg).test({
    //       name: 'is-valid-date-hour',
    //       test: (value) => moment(value, 'HH:mm').isValid(),
    //       message: validationMessages.actionsPlannedTimeHourMsg
    //     }),
    //   otherwise: (schema) => schema.nullable()
    // })
  }

  if (!customFields) {
    return Yup.object().shape({
      baseFields: Yup.object().shape(baseFieldsSchema)
    })
  }

  const fieldsById = buildFieldsById(customFields)

  const customFieldsSchema = customFields.reduce((schema, field) => {
    const { fieldProperties, fieldTypes, internalFieldName, fieldName } = field

    const fieldType = fieldTypes.internalTypeName

    schema[internalFieldName] = Yup.lazy(() => {
      let fieldSchema

      switch (fieldType) {
        case 'inputArea':
          fieldSchema = Yup.string().max(
            fieldProperties.maxLength,
            getMessage('maxLengthError', fieldName, fieldProperties.maxLength)
          )
          break
        case 'inputNumber':
          fieldSchema = Yup.number()
            .max(fieldProperties.maxValue, getMessage('maxValueError', fieldName, fieldProperties.maxValue))
            .min(fieldProperties.minValue, getMessage('minValueError', fieldName, fieldProperties.minValue))
            .nullable()
          break
        case 'upload':
          fieldSchema = Yup.array()
            .max(fieldProperties.maxFilesLength, getMessage('maxFilesError', fieldName, fieldProperties.maxFilesLength))
            .nullable()
          break
        default:
          fieldSchema = Yup.mixed().nullable()
      }

      fieldSchema = fieldSchema.test(
        'conditional-required',
        getMessage('isRequired', fieldName),
        function conditionalRequired(value) {
          // this.parent = objeto de respostas dos custom fields (por internalFieldName)
          if (!evaluateRequired(field, this.parent, fieldsById)) return true
          return hasAnswer(value)
        }
      )

      return fieldSchema
    })

    return schema
  }, {})

  return Yup.object().shape({
    baseFields: Yup.object().shape(baseFieldsSchema),
    customFields: Yup.object().shape(customFieldsSchema)
  })
}
